import { PropertyType } from '../../../models/enum';

export const AggregationColumn = 
{
    modelName: 'aggregationColumnMode',
    propertyType: PropertyType.AggregationMode,
    label: 'Aggregation column',
    placeholder: 'Aggregation column',
    propertyName: 'aggregationColumnModeProperty',
    required: false,
    iconText: 'Σ',
    messages: []
};